export const OFFLINE_WHEEL_FORTUNE_PRIZE_MAP = {
  secretPrize: "secretPrize",
  simpleWineGiftCertificate: "simpleWineGiftCertificate",
  souvenirFlant: "souvenirFlant",
  souvenirPhishman: "souvenirPhishman",
  yaPlus: "yaPlus",
  souvenirAstraGroup: "souvenirAstraGroup",
  paperStickerPack: "paperStickerPack",
  tgStickerPack: "tgStickerPack",
}

export const OFFLINE_WHEEL_FORTUNE_PRIZES = [
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.secretPrize,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.simpleWineGiftCertificate,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.souvenirFlant,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.souvenirPhishman,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.yaPlus,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.souvenirAstraGroup,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.paperStickerPack,
  OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.tgStickerPack,
]



// WEBPACK FOOTER //
// ./src/templates/pages/axoft-wheel-fortune/consts/wheelFortune.js